import { useParams } from 'react-router-dom';
import { useState, useEffect,useRef } from 'react';
import AddContentModal from './AddContentModal';
import AddLessonModal from './AddLessonModal';
import DeleteCMLModal from './DeleteCMLModal';
import ContentLesson from './ContentLesson';
import EditContentModal from './EditContentModal';
const BASE_URL = process.env.REACT_APP_BASE_URL;

const ListCourseContent = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openLessonModal, setOpenLessonModal] = useState(false);
  const [CourseContent, setCourseContent] = useState(null);
  const [selectedModuleId, setSelectedModuleId] = useState(null);
  const [contentEditModal,setContentEditModal]=useState(false)
  const [deleteId, setDeleteId] = useState(null);
  const { id } = useParams();
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null) 
  // console.log("CourseContent",CourseContent)
      const dropdownRef = useRef(null)
       useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setOpenDropdownIndex(null)
        }
      }
    
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }, [dropdownRef])

const fetchCourseContent = async () => {
  try {
    const res = await fetch(`${BASE_URL}/courses/course/list/${id}/`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        'Content-Type': 'application/json',
        "x-api-key": process.env.REACT_APP_X_API_KEY
      },
    });

    const data = await res.json();

    if (res.ok) {
      setCourseContent(data);
    } else {
      console.error('Fetch failed:', data);
    }
  } catch (error) {
    console.error('Error fetching course:', error.message);
  }
};

useEffect(() => {
  fetchCourseContent();
}, [id]);




  return (
    <>
  <div className="p-2 md:p-8 min-h-screen bg-gray-50">
  {/* Course Header */}
  <div className="bg-white rounded-2xl border border-gray-200 p-2 md:p-6 mb-6 shadow-sm">
    <div className="flex items-center gap-3 mb-4">
      <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
        <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      </div>
      <div>
        <h1 className="text-2xl font-bold text-gray-900">{CourseContent?.name || '-'}</h1>
        <p className="text-sm text-gray-500 mt-0.5">Course details and modules</p>
      </div>
    </div>

    <div className="flex items-center gap-2 mb-4">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <span className="text-xs font-semibold text-gray-500 uppercase">Category</span>
      <span className="text-xs px-2.5 py-1 bg-[#e8f0f7] text-[#0f6abf] rounded-lg font-medium">
        {CourseContent?.category_name || '-'}
      </span>
      <span className="text-xs text-gray-400">›</span>
      <span className="text-xs px-2.5 py-1 bg-gray-100 text-gray-700 rounded-lg font-medium">
        {CourseContent?.subcategory_name || '-'}
      </span>
    </div>

    <div className="mt-4 pt-4 border-t border-gray-100">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <p className="text-sm font-semibold text-gray-700">Description</p>
      </div>
      <p className="text-sm text-gray-600 leading-relaxed bg-gray-50 rounded-xl p-4">
        {CourseContent?.description || '-'}
      </p>
    </div>

    <div className="mt-4 flex justify-end">
      <button
        onClick={() => setOpenModal(true)}
        className="px-4 py-2 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center gap-2"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
        </svg>
        Add Module
      </button>
    </div>
  </div>

  {/* Modules Section */}
  <div className="bg-white rounded-2xl border border-gray-200 shadow-sm">
    <div className="flex items-center justify-between p-2 md:p-6 border-b border-gray-200">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
        </div>
        <div>
          <h2 className="text-lg font-semibold text-gray-900">Course Modules</h2>
          <p className="text-sm text-gray-500 mt-0.5">Manage your course content</p>
        </div>
      </div>
      <span className="text-xs px-3 py-1.5 bg-gray-100 text-gray-700 rounded-lg font-medium">
        {CourseContent?.modules?.length || 0} modules
      </span>
    </div>

    {/* Dynamic Modules */}
    <div className="p-2 md:p-6">
      {CourseContent?.modules?.length > 0 ? (
        <div className="space-y-4">
          {CourseContent.modules.map((module, index) => (
            <div key={module.id} className="border border-gray-200 rounded-xl overflow-hidden">
              <div className="flex flex-col md:flex-row justify-between items-start md:items-center p-6 bg-gray-50/50 gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-3">
                    <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                    <h3 className="text-base font-semibold text-gray-900">
                      Module {index + 1}: {module.title || '-'}
                    </h3>
                  </div>
                  <div className="flex items-center gap-4">
                    <span className="flex items-center gap-2 text-xs text-gray-600">
                      <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                      </svg>
                      {module.lessons?.length || 0} lessons
                    </span>
                  </div>
                </div>

                <div className="flex gap-2">
                  <button
                    onClick={() => {
                      setSelectedModuleId(module.id);
                      setOpenLessonModal(true);
                    }}
                    className="px-3 py-2 bg-[#0f6abf] text-white text-xs font-medium rounded-lg hover:bg-[#0a5ca8] transition-colors flex items-center gap-1"
                  >
                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                    </svg>
                    Add Lesson
                  </button>

                  <button
                    onClick={() => {
                      setSelectedModuleId(module.id);
                      setContentEditModal(true);
                    }}
                    className="w-9 h-9 flex items-center justify-center bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
                    title="Edit Module"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                  </button>

                  <button
                    onClick={() => setDeleteId(module.id)}
                    className="w-9 h-9 flex items-center justify-center bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition-colors"
                    title="Delete Module"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                </div>
              </div>

              {/* Lessons */}
              <div className=" md:px-6 pb-6">
                <ContentLesson module={module} fetchCourseContent={fetchCourseContent} />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
          </div>
          <h3 className="text-lg font-medium text-gray-700 mb-2">No modules added yet</h3>
          <p className="text-sm text-gray-500 mb-4">Start by creating your first module to build your course</p>
          <button
            onClick={() => setOpenModal(true)}
            className="px-4 py-2 bg-[#e8f0f7] text-[#0f6abf] text-sm font-medium rounded-lg hover:bg-[#d0e0f0] transition-colors"
          >
            Create First Module
          </button>
        </div>
      )}
    </div>
  </div>
</div>


      <AddContentModal openModal={openModal} setOpenModal={setOpenModal}  id={id}  fetchCourseContent={fetchCourseContent}/>
      <EditContentModal contentEditModal={contentEditModal} setContentEditModal={setContentEditModal} moduleId={selectedModuleId}  fetchCourseContent={fetchCourseContent}/>
      <DeleteCMLModal deleteId={deleteId} setDeleteId={setDeleteId} type="module" fetchCourseContent={fetchCourseContent}/>
      <AddLessonModal
        openLessonModal={openLessonModal}
        setOpenLessonModal={setOpenLessonModal}
        moduleId={selectedModuleId}
        fetchCourseContent={fetchCourseContent}
      />
     
    </>
  );
};

export default ListCourseContent;
